export const USER_ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  COACH: 'COACH',
  USER: 'USER',
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  SUPER_ADMIN: 'Super Admin',
  COACH: 'Coach',
  USER: 'User',
};
